import { useEffect, useState } from 'react';
import { getMyReferral } from '@/shared/services/referralsService';
import { useToast } from '@/shared/contexts/ToastContext';
import { PanelTitle } from './PanelTitle';

/** Link de referencia (/cadastro?ref=CODE) — nao existe no mock, mantido do painel antigo. */
export function ReferralPanel() {
  const { notify } = useToast();
  const [code, setCode] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    getMyReferral()
      .then((r) => setCode(r.code))
      .catch(() => setCode(null))
      .finally(() => setLoading(false));
  }, []);

  const url = code ? `${window.location.origin}/cadastro?ref=${code}` : '';

  const copy = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      notify('success', 'Link copiado!');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      notify('error', 'Não foi possível copiar');
    }
  };

  return (
    <section className="panel-surface referral-panel">
      <PanelTitle icon="⚭" title="Link de Referência" subtitle="Compartilhe seu link e ajude o servidor a crescer" />
      {loading ? (
        <div className="panel-empty">Carregando…</div>
      ) : !code ? (
        <div className="panel-empty">Não foi possível obter seu código no momento.</div>
      ) : (
        <div className="referral-row">
          <code title={url}>{url}</code>
          <button className="btn btn-dark" onClick={copy}>{copied ? '✓ Copiado' : '⧉ Copiar link'}</button>
        </div>
      )}
    </section>
  );
}
